import { createStore, compose } from "redux";
import { combineReducers } from "redux";
import { searchResults } from "./reducers/search-result-items";
import { newsSearchResults } from "./reducers/news-search-result-items";
import { pageSize } from "./reducers/pageSize";

const rootReducer = combineReducers({
    searchResults,
    newsSearchResults,
    pageSize,
});

const store = createStore(
    rootReducer,
    compose(
        // @ts-ignore
        window.__REDUX_DEVTOOLS_EXTENSION__
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : (f) => f
    )
);

export default store;
